import { render } from "./FormularioProducto.vue?vue&type=template&id=3ebd32d7&scoped=true"
import script from "./FormularioProducto.vue?vue&type=script&lang=js"
export * from "./FormularioProducto.vue?vue&type=script&lang=js"

import "./FormularioProducto.vue?vue&type=style&index=0&id=3ebd32d7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebd32d7"]])

export default __exports__